import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import { isFunction } from '@utiljs/is';
import { getValueFromObjOrArray } from './utils';
import { connect } from './connect';
/**
 * 方法对应的都是 Form 上值的变动
 * Field 接收 name 才能进行数据绑定
 */

var FieldArray = /*#__PURE__*/function (_React$Component) {
  _inherits(FieldArray, _React$Component);

  var _super = _createSuper(FieldArray);

  function FieldArray() {
    var _this;

    _classCallCheck(this, FieldArray);

    _this = _super.apply(this, arguments);
    _this.arrayValue = [];

    _this.pop = function () {
      _this.arrayValue.pop();

      _this.set();
    };

    _this.push = function (value) {
      _this.arrayValue.push(value);

      _this.set();
    };

    _this.shift = function () {
      _this.arrayValue.shift();

      _this.set();
    };

    _this.unshift = function (value) {
      _this.arrayValue.unshift(value);

      _this.set();
    };

    _this.insert = function (index, value) {
      _this.arrayValue.splice(index, 0, value);

      _this.set();
    }; // 删除


    _this.remove = function (index) {
      _this.arrayValue.splice(index, 1);

      _this.set();
    }; // 更新


    _this.update = function (index, value) {
      _this.arrayValue[index] = value;

      _this.set(_this.arrayValue);
    }; // 值交换


    _this.swap = function (firstIndex, secondIndex) {
      var temp = _this.arrayValue[firstIndex];
      _this.arrayValue[firstIndex] = _this.arrayValue[secondIndex];
      _this.arrayValue[secondIndex] = temp;

      _this.set(_this.arrayValue);
    };

    _this.set = function (value) {
      var _this$props = _this.props,
          form = _this$props.form,
          name = _this$props.name;
      var handleChange = form.handleChange;
      handleChange(name, value || _this.arrayValue);
    };

    _this.renderChildren = function () {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          name = _this$props2.name;
      var action = {
        pop: _this.pop,
        push: _this.push,
        shift: _this.shift,
        unshift: _this.unshift,
        update: _this.update,
        remove: _this.remove,
        swap: _this.swap,
        insert: _this.insert
      };

      if ( /*#__PURE__*/React.isValidElement(children)) {
        return children;
      } else if (isFunction(children)) {
        return children({
          fields: _this.arrayValue,
          action: action,
          name: name
        });
      }

      return children;
    };

    return _this;
  }

  _createClass(FieldArray, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          form = _this$props3.form,
          name = _this$props3.name,
          children = _this$props3.children;
      var values = form.values;

      if (!name) {
        return children || null;
      }

      this.arrayValue = _toConsumableArray(getValueFromObjOrArray(values, name) || []);
      return /*#__PURE__*/React.createElement("div", null, this.renderChildren());
    }
  }]);

  return FieldArray;
}(React.Component);

FieldArray.propTypes = {
  name: PropTypes.string.isRequired
};
export default connect(FieldArray); // TODO
// 为 Field 自动传入 name？ 拼接的成本还是挺大的。
// 输出的是有序数组，与 index 无关，所以可以进行插入操作。
// rule 需要一一对应，如果需要每个项都有状态，那么就要每个 Field 增加 rule （麻烦，但是可以解决需求）